function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 9.25C1.5 4.96979 4.96979 1.5 9.25 1.5C13.2274 1.5 16.5049 4.49616 16.9488 8.35459L14.7792 6.77343C14.4847 6.55876 14.0766 6.64566 13.8678 6.96754C13.6591 7.28943 13.7286 7.72438 14.0232 7.93905L16.7817 9.94907L16.78 9.95776L16.7987 9.96144L17.349 10.3624L17.3517 10.3649C17.4597 10.4634 17.5904 10.5162 17.7236 10.5251C17.9504 10.543 18.1827 10.4328 18.3239 10.2151L18.3323 10.2018L20.8312 7.11644C21.0712 6.82016 21.047 6.3783 20.7772 6.12948C20.5074 5.8806 20.0942 5.91906 19.8542 6.21534L18.4152 7.99214C17.8015 3.47851 13.932 0 9.25 0C4.14137 0 0 4.14137 0 9.25C0 14.3586 4.14137 18.5 9.25 18.5C11.9605 18.5 14.3989 17.3335 16.0898 15.4774C16.3688 15.1712 16.3063 14.6978 15.9786 14.4444C15.651 14.1911 15.1824 14.2543 14.8987 14.5561C13.4843 16.0614 11.4769 17 9.25 17C4.96979 17 1.5 13.5302 1.5 9.25Z",
  fill: "#1C1C1C"
});

function SvgIcRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefresh);
export default __webpack_public_path__ + "static/media/ic_refresh.84dc112d89e248440fe4dde0b894752a.svg";
export { ForwardRef as ReactComponent };